import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('IncomingConcurrentMessageNotification');

Factory.define('IncomingConcurrentMessageNotificationWithDefaults')
  .extend('IncomingConcurrentMessageNotification')
  .attr('type', 'INCOMING_CONCURRENT_MESSAGE')
  .attr('profile', () => Factory.attributes('SessionCustomerWithDefaults'))
  .attr('conversationId', 'conversation-id')
  .attr('conversationItem', () => Factory.attributes('SmsMessageItemWithDefaults'))
  .attr('id', ['conversationItem'], conversationItem => conversationItem.id);

Factory.define('IncomingConcurrentMessageNotificationWithSMS')
  .extend('IncomingConcurrentMessageNotificationWithDefaults')
  .attr('conversationItem', () => Factory.attributes('SmsMessageItemWithDefaults'));

Factory.define('IncomingConcurrentMessageNotificationWithChatMessage')
  .extend('IncomingConcurrentMessageNotificationWithDefaults')
  .attr('conversationItem', () => Factory.attributes('ChatMessageItemWithDefaults'));

Factory.define('IncomingConcurrentMessageNotificationWithConversationMessage')
  .extend('IncomingConcurrentMessageNotificationWithDefaults')
  .attr('conversationItem', () => Factory.attributes('ConversationMessageItemWithDefaults'));

Factory.define('IncomingConcurrentMessageNotificationWithFBMessage')
  .extend('IncomingConcurrentMessageNotificationWithDefaults')
  .attr('conversationItem', () => Factory.attributes('FbMessageIncomingItemWithText'));



// WEBPACK FOOTER //
// ./factories/incoming_concurrent_message_notification_factory.js